import UpgradeFreePlanModal from '@/components/Modals/UpgradeFreePlanModal';
import { AvatarListPageContextProvider, useAvatarListPageContext } from '@/pages/avatar/ListPage/contex';
import { ModerationModal } from '@/pages/editor/layout/ModerationModal';
import styled from '@emotion/styled';
import { useSceneNotifications } from '../hooks';
import { DeleteAvatarModal, Filters, GenerateAvatarModal, Header, Library } from './components';
import SuggestionCardList from './components/Suggestions/SuggestionCardList';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const AvatarListPage = () => {
    const { filtersHidden } = useAvatarListPageContext();
    useSceneNotifications();

    return (
        <>
            <Container>
                <Header />
                <SuggestionCardList />
                {!filtersHidden && <Filters />}
                <Library />
            </Container>

            <ModerationModal />
            <DeleteAvatarModal />
            <GenerateAvatarModal />
            <UpgradeFreePlanModal from="avatar-library" />
        </>
    );
};

const WrappedAvatarListPage = () => (
    <AvatarListPageContextProvider>
        <AvatarListPage />
    </AvatarListPageContextProvider>
);

export { WrappedAvatarListPage as AvatarListPage };
